import { HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NmsDialogService } from "@nms-angular-toolkit/nms-dialog";
import { ErrorResponseHandlerService } from "@nms-ng2/app/core/services/error-response-handler/error-response-handler.service";
import { catchError } from "rxjs/operators";
import { Observable, of } from "rxjs";
import {
    DwdmAmplifierData,
    DwdmAmplifierRequestData
} from "../amplifiers-step.model";

/**
 * Serviço responsável por retornar os dados dos amplificadores.
 */
@Injectable({
    providedIn: "root"
})
export class AmplifiersService {
    baseUrl = "/web/topology/circuit/dwdm";

    constructor(private readonly http: HttpClient,
        private readonly errorResponseHandlerService: ErrorResponseHandlerService,
        private readonly nmsDialogService: NmsDialogService) {}

    getAmplifiers(amplifiersRequest: DwdmAmplifierRequestData): Observable<DwdmAmplifierData[]> {
        const { deviceAEnd , deviceZEnd, linkIds} =  amplifiersRequest;
        let params = new HttpParams()
            .append("deviceAEndResourceId", String(deviceAEnd))
            .append("deviceZEndResourceId", String(deviceZEnd))
            .append("linkIds", linkIds.join(","));

        return this.http
            .get<DwdmAmplifierData[]>(`${this.baseUrl}/options/amplifiers`, { params })
            .pipe(catchError((error) => {
                this.handleError(error);
                return of([]);
            }));
    }

    private handleError(error: HttpErrorResponse): void {
        const { description, details } = this.errorResponseHandlerService.buildErrorDescriptionDetails(error.error);
        this.nmsDialogService.openDialog(
            { description: description + details, acceptLabel: "OK", bindHtml: true },
            { maxWidth: "800px" }
        );
    }

}
